<template>
    <Button v-bind="$props" variant="text" color="black" :border="border" :font="font">
        <slot />
    </Button>
</template>

<script lang="ts">
    import { defineComponent, computed } from 'vue';
    import Button, { buttonProps } from './Button.vue';
    export default defineComponent({
        name: 'ButtonText',
        components: { Button },
        props: buttonProps,
        setup(props) {
            const font = computed(() => {
                switch (props.size) {
                    case 's':
                        return 'font-link-s';
                    case 'm':
                        return 'font-link-m';
                    default:
                        return 'font-link-l';
                }
            });

            const border = computed(() => {
                switch (props.size) {
                    case 's':
                        return 'square';
                    default:
                        return 'radius';
                }
            });

            return { font, border };
        },
    });
</script>
